<!--
 * @Author: DY
 * @Date: 2021-10-18 18:20:34
 * @LastEditTime: 2024-12-06 15:53:08
 * @Description:
 * @Param:
 * @FilePath: \ShiMo_Web\src\components\picturePreview\index.vue
-->

<template>
    <div class="picturePreview">
        <el-carousel :interval="5000" arrow="always" :autoplay="false">
            <el-carousel-item v-for="(item, index) in imgSrc" :key="index">
                <iframe :src="item" frameborder="0"></iframe>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    // 图片预览
    name: 'picture-preview',
    components: {},
    props: {
        code: {
            type: [Array, Object, String],
            required: false, // 是否必传
        },
        extr: {
            type: [Array, Object, String],
            required: false, // 是否必传
        },
    },
    data() {
        return {
            // 附件集合
            imgSrc: [],
        };
    },
    watch: {},
    computed: {},
    methods: {},
    created() {
    },
    mounted() {
        let params = this.extr;
        if (this.code && Object.keys(this.code).length > 0) {
            params = this.code;
        }
        if (params.imgSrc.length > 0) {
            this.imgSrc = params.imgSrc;
        } else if (params.picturePreview.length > 0) {
            params.picturePreview.forEach(item => {
                item = `${this.FILE.FILE_BASE_URL()}file-manage/preview/${item}`;
                this.imgSrc.push(item);
            });
        }
    },

};
</script>
<style lang="stylus">
.picturePreview
    height 100%
    padding 10px
    .el-carousel--horizontal, .el-carousel__container
        height 100% !important
        overflow hidden
        iframe
            width 100%
            height 100%
</style>

